import { render, staticRenderFns } from "./buttonLinkRowBlock.vue?vue&type=template&id=09cf8978&scoped=true"
import script from "./buttonLinkRowBlock.vue?vue&type=script&lang=js"
export * from "./buttonLinkRowBlock.vue?vue&type=script&lang=js"
import style0 from "./buttonLinkRowBlock.vue?vue&type=style&index=0&id=09cf8978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf8978",
  null
  
)

export default component.exports